import { render } from "./5.Languages.vue?vue&type=template&id=001a3aab&scoped=true"
import script from "./5.Languages.vue?vue&type=script&lang=js"
export * from "./5.Languages.vue?vue&type=script&lang=js"

import "./5.Languages.vue?vue&type=style&index=0&id=001a3aab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001a3aab"]])

export default __exports__